import React from 'react';
import "./App.css"


export const getColorFromScore = (score) => {

  // Clamp le score entre -1 et 1
  const clamped = Math.max(-1, Math.min(1, score));

  // On va interpoler entre rouge clair (255, 200, 200), blanc (255, 255, 255), et vert clair (200, 255, 200)
  let r, g, b;

  if (clamped < 0) {
    // Entre -1 et 0 : rouge clair → blanc
    const t = (clamped + 1); // t de 0 (rouge clair) à 1 (blanc)
    r = 255;
    g = Math.round(200 + 55 * t);
    b = Math.round(200 + 55 * t);
  } else {
    // Entre 0 et 1 : blanc → vert clair
    const t = clamped; // t de 0 (blanc) à 1 (vert clair)
    r = Math.round(255 - 55 * t);
    g = 255;
    b = Math.round(255 - 55 * t);
  }

  return `rgb(${r}, ${g}, ${b})`;
};



const ScoreBox = ({score, percent=true}) => {

    const backgroundColor = getColorFromScore(score);

    const scoreStr = percent ? Math.round(score*100).toString()+"%" : score.toString()
    return (
    <span className={"scorebox"} style={{backgroundColor}}>
      {scoreStr}
    </span>
  );
}

export default ScoreBox;

